import React, { useEffect } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import brokerConfig from '../config/brokerConfig';

const ContactUs = ({ onChatTrigger }) => {
  useEffect(() => {
    document.body.setAttribute('data-page', 'support');
    return () => {
      document.body.removeAttribute('data-page');
    };
  }, []);

  const handleChatClick = () => {
    if (brokerConfig.support?.type === 'whatsapp') {
      const number = brokerConfig.support?.number;
      if (number) {
        window.open(`https://wa.me/${number}`, '_blank');
      }
    } else if (brokerConfig.support?.type === 'zoho') {
      if (onChatTrigger) {
        onChatTrigger();
      } else {
        console.error("Zoho Support Chat trigger not attached.");
      }
    }
  };

  const supportType = brokerConfig.support?.type;

  return (
    <Box sx={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper elevation={3} sx={{ maxWidth: 400, width: '100%', p: 4, textAlign: 'center', borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={700} mb={1}>Contact Us</Typography>
        <Typography variant="body1" color="text.secondary" mb={3}>
          Need help? Our support team is here for you. Chat with us for instant assistance.
        </Typography>
        {(supportType === 'zoho' || supportType === 'whatsapp') ? (
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<ChatIcon />}
            onClick={handleChatClick}
            sx={{
              borderRadius: 8,
              fontWeight: 600,
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              boxShadow: 3,
              minWidth: 180
            }}
          >
            Chat Now
          </Button>
        ) : (
          <Typography variant="body2" color="text.secondary">
            Support functionality will be available soon.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default ContactUs;
